<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <form>
        <vx-card>
          <vs-row vs-w="12" class="mb-5">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="4" vs-xs="12">
              <vs-button @click="goBack" icon="keyboard_backspace">Back</vs-button>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
              <h3>Add Client</h3>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="4" vs-xs="12">
            </vs-col>
          </vs-row>
          <vs-divider class="m-5" />
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Select Account:</span>
            </div>

            <AccountAutocomplete :key="companySearchComponentKey" class="searchbox" :list="searchAccount"
              :searchOn="'company_or_registration_no'" @event-name="handleChildEvent"></AccountAutocomplete>

          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>This Company is a Sole Trader:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <!-- <input type="checkbox" v-model="IsSoleTrader"/> -->
              <vs-switch vs-icon-on="check_box" vs-icon-off="block" v-model="clientDescription.is_sole_trader">
                <span slot="on">YES</span>
                <span slot="off">NO</span>
              </vs-switch>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Company Name:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" name="company_name" v-model="clientDescription.company_name"
                v-validate="'required'" data-vv-as="Company Name" />
            </div>
            <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('company_name')">{{
              errors.first("company_name") }}</span>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Company Registration Number:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" name="company_registration_number"
                v-model="clientDescription.company_registration_number"
                v-validate="{ required: !this.clientDescription.is_sole_trader }"
                data-vv-as="Company Registration Number" />
            </div>
            <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('company_registration_number')">{{
              errors.first("company_registration_number") }}</span>
          </div>
          <!-- <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Company Head Office Country:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="head_office_country"
                v-validate="'required'"
                v-model="clientDescription.head_office_country"
                data-vv-as="Head Office Country"
                @click="editHeadOfficeCountry"
                v-show="showHeadOfficeCountryField"
              />
              <ClientAutocomplete
                ref="EditAutoComplete"
                class="searchbox"
                :list="getCountries"
                :searchOn="'head_office_country'"
                v-show="showEditAutocomplete"
              ></ClientAutocomplete>
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('head_office_country')"
              >{{ errors.first("head_office_country") }}</span
            >
          </div> -->
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Company Status:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" name="company_status" v-validate="'required'" v-model="clientDescription.status"
                data-vv-as="Company Status" />
            </div>
            <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('company_status')">{{
              errors.first("company_status") }}</span>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Company Category:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" name="company_category" v-model="clientDescription.company_category"
                data-vv-as="Company Category" />
            </div>
            <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('company_category')">{{
              errors.first("company_category") }}</span>
          </div>
          <vs-divider class="m-5" />

          <!-- Registered Office -->
          <h5 class="mb-5">Registered Office Address</h5>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Address Line 1:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" name="registered_office_address_1"
                v-model="clientDescription.registered_office_address_1" />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Address Line 2:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" v-model="clientDescription.registered_office_address_2" />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Address Line 3:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" v-model="clientDescription.registered_office_address_3" />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>City:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" v-model="clientDescription.registered_office_city" />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>County:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" v-model="clientDescription.registered_office_county" />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Postcode:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" v-model="clientDescription.registered_office_postcode" />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Country:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <AccountAutocomplete ref="clientAddRegisteredOfficeCountryRef" :chosen="selected_registered_office_country"
                class="searchbox" :list="getCountries" :searchOn="'registered_office_country'">
              </AccountAutocomplete>
              <!-- <vs-input
                class="w-full"
                v-model="clientDescription.registered_office_country"
              /> -->
            </div>
            <span v-if="registered_office_country_validation" class="text-danger text-sm mt-2 ml-16">{{
              registered_office_country_validation }}</span>
          </div>
          <vs-divider class="m-5" />

          <!-- Head Office -->
          <h5 class="mb-5">Head Office Address</h5>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Head Office Address is the Same As the Registered Office
                Address:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <!-- <input type="checkbox" v-model="headOfficeIsRegisteredOffice"/> -->
              <vs-switch vs-icon-on="check_box" vs-icon-off="block" v-model="headOfficeIsRegisteredOffice">
                <span slot="on">YES</span>
                <span slot="off">NO</span>
              </vs-switch>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Address Line 1:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" v-model="clientDescription.head_office_address_1" name="head_office_address_1" />
            </div>

          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Address Line 2:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" v-model="clientDescription.head_office_address_2" />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Address Line 3:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" v-model="clientDescription.head_office_address_3" />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>City:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" name="head_office_city" v-model="clientDescription.head_office_city" />
            </div>

          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>County:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" v-model="clientDescription.head_office_county" />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Postcode:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" v-model="clientDescription.head_office_postcode" />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Country:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <AccountAutocomplete ref="clientAddHeadOfficeCountryRef" :chosen="selected_head_office_country"
                class="searchbox" :list="getCountries" :searchOn="'head_office_country'">
              </AccountAutocomplete>
              <!-- <vs-input
                class="w-full"
                v-model="clientDescription.head_office_country"
              /> -->
            </div>
            <span v-if="head_office_country_validation" class="text-danger text-sm mt-2 ml-16">{{
              head_office_country_validation }}</span>

          </div>
          <vs-divider class="m-5" />
          <div class="vx-row">
            <h6 class="p-5">Website URLs</h6>
          </div>
          <template v-if="clientDescription.web && clientDescription.web.length > 0">
          </template>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <vs-input class="w-full" name="website_url" v-validate="'url:require_protocol'" v-model="clients.web"
                data-vv-as="website" />
            </div>

            <div class="vx-col sm:w-1/3 w-full">
              <vs-button @click="addWebsite" color="primary" type="filled">Add</vs-button>
              <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('website_url')">{{
                errors.first("website_url") }}</span>
            </div>
          </div>

          <template v-for="website in clientDescription.web">
            <span class="p-5">
              <p>
                {{ website.url }}
                <vs-icon class="ml-10 removeButton" @click="removeSelectedWeb(website)" color="success"
                  icon="clear"></vs-icon>
              </p>
            </span>
          </template>

          <vs-divider class="m-5" />
          <div class="vx-row">
            <h6 class="p-5">Social Media Pages</h6>
          </div>
          <template v-if="
            clientDescription.linkedin &&
            clientDescription.linkedin.length > 0
          ">
          </template>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <vs-input v-validate="'url:require_protocol'" class="w-full" name="linkedin" v-model="clients.linkedin" />
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-button color="primary" @click="addLinkedin" type="filled">Add</vs-button>
              <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('linkedin')">{{ errors.first("linkedin")
              }}</span>
            </div>
          </div>

          <template v-for="link in clientDescription.linkedin">
            <span class="p-5">
              <p>
                {{ link.url }}
                <vs-icon class="ml-10 removeButton" @click="removeSelectedLinkedin(link)" color="success"
                  icon="clear"></vs-icon>
              </p>
            </span>
          </template>
          <vs-divider class="m-5" />

          <!-- Site Office -->
          <h5 class="mb-5">Site Office Address</h5>
          <template v-for="(site, index) in clientDescription.satellite_office">
            <div :key="index">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>Address Line 1:</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <vs-input class="w-full" name="satellite_office_address_1" data-vv-as="Address Line 1"
                    v-model="site.address_1" />
                </div>
                <vs-icon class="ml-10 removeButton" @click="removeSelectedSiteAddress(site)" color="success"
                  icon="clear"></vs-icon>

              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>Address Line 2:</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <vs-input class="w-full" v-model="site.address_2" />
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>Address Line 3:</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <vs-input class="w-full" v-model="site.address_3" />
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>City:</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <vs-input class="w-full" v-model="site.city" />
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>County:</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <vs-input class="w-full" v-model="site.county" />
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>Postcode:</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <vs-input class="w-full" v-model="site.postcode" />
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>Telephone:</span>
                </div>

                <div class="vx-col sm:w-1/3 w-full">
                  <vs-input class="w-full" v-model="site.phone" />
                </div>
              </div>
              <!-- <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>Telephone:</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <template v-for="(site_ph, ph_index) in site.phone">
                    <div
                      :key="ph_index"
                      v-if="site_ph.satellite_office_id == site.id"
                    >
                      <vs-input class="w-full" v-model="site_ph.phone_no" />
                    </div>
                  </template>
                </div>
              </div> -->
            </div>
            <vs-divider class="m-5" />

          </template>
          <vs-col class="mb-5" vs-offset="4" vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
            <vs-button color="primary" @click="addSiteOffice" type="filled">Add Satellite Office</vs-button>
          </vs-col>

          <vs-divider class="m-5" />
          <!-- Telephone -->
          <div class="vx-row">
            <h6 class="p-5">Telephone Number(s)</h6>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <vs-input class="w-full" v-model="clients.phone" />
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <v-select label="name" :options="clients.phoneTypes" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="clients.phoneType" />
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-button color="primary" @click="addPhoneNumbers" type="filled">Add</vs-button>
            </div>
          </div>
          <!-- <template v-for="phoneAndType in clients.joinedPhoneAndTypes">
            <p class="m-10">
              {{ phoneAndType }}
              <vs-icon
                class="ml-10 removeButton"
                @click="removeNewSelectedPhone(phoneAndType)"
                color="success"
                icon="clear"
              ></vs-icon>
            </p>
          </template> -->
          <template v-if="clientDescription.phone && clientDescription.phone.length > 0">
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">

                <template v-for="phone in clientDescription.phone">
                  <template v-if="phone.phone_type == 'head_office_switchboard'">
                    <p class="m-10">
                      Head Office Switchboard - {{ phone.phone_no }}
                      <vs-icon class="ml-10 removeButton" @click="removeSelectedPhone(phone)" color="success"
                        icon="clear"></vs-icon>
                    </p>
                  </template>
                  <template v-if="phone.phone_type == 'site_switchboard'">
                    <p class="m-10">
                      Site Switchboard - {{ phone.phone_no }}
                      <vs-icon class="ml-10 removeButton" @click="removeSelectedPhone(phone)" color="success"
                        icon="clear"></vs-icon>
                    </p>
                  </template>

                  <template v-if="phone.phone_type == 'customer_service'">
                    <p class="m-10">
                      Customer Service - {{ phone.phone_no }}
                      <vs-icon class="ml-10 removeButton" @click="removeSelectedPhone(phone)" color="success"
                        icon="clear"></vs-icon>
                    </p>
                  </template>

                  <template v-if="phone.phone_type == 'sales_line'">
                    <p class="m-10">
                      Sales Line - {{ phone.phone_no }}
                      <vs-icon class="ml-10 removeButton" @click="removeSelectedPhone(phone)" color="success"
                        icon="clear"></vs-icon>
                    </p>
                  </template>

                  <template v-if="phone.phone_type == 'customer_support_line'">
                    <p class="m-10">
                      Customer Support Line - {{ phone.phone_no }}
                      <vs-icon class="ml-10 removeButton" @click="removeSelectedPhone(phone)" color="success"
                        icon="clear"></vs-icon>
                    </p>
                  </template>

                  <template v-if="phone.phone_type == 'others'">
                    <p class="m-10">
                      Others - {{ phone.phone_no }}
                      <vs-icon class="ml-10 removeButton" @click="removeSelectedPhone(phone)" color="success"
                        icon="clear"></vs-icon>
                    </p>
                  </template>
                </template>
              </div>
              <div class="vx-col sm:w-1/3 w-full"></div>
            </div>
          </template>
          <!-- Sic Code -->
          <div class="vx-row">
            <h6 class="p-5">Sic Codes(s)</h6>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">

              <AccountAutocomplete ref="SicCodeRef" class="searchbox" :chosen="selected_sic_code" :list="getSicCodes"
                :searchOn="'sic_codes'"></AccountAutocomplete>

              <!-- <vs-input type="number" class="w-full" v-model="accounts.sic_code" /> -->
            </div>
            <!-- <div class="vx-col sm:w-1/3 w-full">
                <vs-input class="w-full" v-model="accounts.sic_code_description" />
            </div> -->
            <div class="vx-col sm:w-1/3 w-full">
              <vs-button color="primary" @click="addSicCode" type="filled">Add</vs-button>
            </div>
          </div>
          <!-- <template v-for="sic in clients.joinedSicAndDescription">
            <p class="m-10">
              {{ sic }}
              <vs-icon
                class="ml-10 removeButton"
                @click="removeNewSelectedSicCode(sic)"
                color="success"
                icon="clear"
              ></vs-icon>
            </p>
          </template> -->
          <template v-if="
            clientDescription.sic_code &&
            clientDescription.sic_code.length > 0
          ">
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <template v-for="sic in clientDescription.sic_code">
                  <p class="m-10">
                    <!-- {{ sic.sic_code_detail.code }}                     {{ sic.sic_code_detail.description }} -->
                    {{ sic.name }}
                    <!-- {{ sic.code }} - {{ sic.description }} -->
                    <vs-icon class="ml-10 removeButton" @click="removeSelectedSicCode(sic)" color="success"
                      icon="clear"></vs-icon>
                  </p>
                </template>
              </div>
              <div class="vx-col sm:w-1/3 w-full"></div>
            </div>
          </template>
          <vs-divider class="m-5" />
          <h5 class="mb-5">Other Details</h5>
          <div class="vx-row">
            <div class="vx-col sm:w-1/2 w-full">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>Registration Jurisdiction:</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <AccountAutocomplete ref="RegistrationJurisdictionRef" :chosen="selected_registration_jurisdiction"
                    class="searchbox" :list="getCountries" :searchOn="'registration_jurisdiction'">
                  </AccountAutocomplete>
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>Parent Company:</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <ClientAutocomplete class="searchbox" :list="getParentCompany" :searchOn="'parent'">
                  </ClientAutocomplete>
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>Vertical:</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <AccountAutocomplete ref="VerticalRef" class="searchbox" :chosen="selected_vertical"
                    :list="getVerticals" :searchOn="'vertical'"></AccountAutocomplete>
                </div>
              </div>
              <!-- <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>NDA Completed:</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                <vs-checkbox
                      v-model="nda_completed"
                      name="nda_completed"
                      ></vs-checkbox
                    >
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>SOW Completed:</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                 <vs-checkbox
                      v-model="sow_completed"
                      name="sow_completed"
                      ></vs-checkbox
                    >
                </div>
              </div> -->
              <!-- <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>Email Address Provided:</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                <vs-checkbox
                      v-model="email_provided"
                      name="email_provided"
                      ></vs-checkbox
                    >
                </div>
              </div> -->
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>Email Address Host:</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <vs-input class="w-full" name="email_host" data-vv-as="Email Address Host" v-model="email_host" />
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>NDA document:</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <vs-input @change="uploadNDADocument" ref="nda_document" type="file" class="w-full" name="nda_document"
                    v-model="nda_document" />
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>SOW document:</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <vs-input @change="uploadSOWDocument" ref="sow_document" type="file" class="w-full" name="sow_document"
                    v-model="sow_document" />
                </div>
              </div>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>NDA Due By:</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <flat-pickr class="flat-pick" :config="configDatePicker" v-model="nda_due_by"
                    placeholder="Choose Date" />
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>SOW Due By:</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <flat-pickr class="flat-pick" :config="configDatePicker" v-model="sow_due_by"
                    placeholder="Choose Date" />
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>NDA Expires on:</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <flat-pickr class="flat-pick" :config="configDatePicker" v-model="nda_expires_on"
                    placeholder="Choose Date" />
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>SOW Expires on:</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <flat-pickr class="flat-pick" :config="configDatePicker" v-model="sow_expires_on"
                    placeholder="Choose Date" />
                </div>
              </div>

              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>Email Address Due By:</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <flat-pickr class="flat-pick" :config="configDatePicker" v-model="email_due_by"
                    placeholder="Choose Date" />
                </div>
              </div>
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full"></div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-button class="mr-3 mb-2" @click.prevent="submitForm">Submit</vs-button>
            </div>
          </div>
        </vx-card>
      </form>
      <template v-if="clientExists">
        <vs-popup fullscreen :title="ExistedClientDescription.company_name" :active.sync="popupActive">
          <div class="flex justify-between flex-wrap">
            <vs-button class="mb-4 mr-6" @click="accept()" type="border">Accept</vs-button>
            <vs-button class="mb-4" type="border" @click="reject()" color="primary">Reject</vs-button>
          </div>
          <vs-list>
            <vs-list-header title="Key Company Details" color="success"></vs-list-header>
            <vs-list-item title="Company Name ">
              {{ ExistedClientDescription.company_name }}
            </vs-list-item>
            <vs-list-item title="Company Registration Number">
              {{ ExistedClientDescription.company_registration_number }}
            </vs-list-item>
            <vs-list-item title="Switchboard">
              <template v-for="(ph, index) in ExistedClientDescription.phone">
                <div :key="index">
                  <template v-for="(ph_type, index2) in ph.phone_type">
                    <div :key="index2" v-if="
                      ph_type.type == 'Switchboard' &&
                      ph_type.phone_id == ph.id
                    ">
                      {{ ph.phone_no }}
                    </div>
                  </template>
                </div>
              </template>
            </vs-list-item>
            <vs-list-item title="Site Switchboard">
              <template v-for="(ph, index) in ExistedClientDescription.phone">
                <div :key="index">
                  <template v-for="(ph_type, index2) in ph.phone_type">
                    <div :key="index2" v-if="
                      ph_type.type == 'Site Switchboard' &&
                      ph_type.phone_id == ph.id
                    ">
                      {{ ph.phone_no }}
                    </div>
                  </template>
                </div>
              </template>
            </vs-list-item>
          </vs-list>

          <vs-list>
            <vs-list-header title="Address" color="success"></vs-list-header>
            <vs-list-item title="Head Office Address">
              {{ ExistedClientDescription.head_office_address_1 }}
              {{ ExistedClientDescription.head_office_address_2 }}
              {{ ExistedClientDescription.head_office_address_3 }}
              {{ ExistedClientDescription.head_office_city }}
              {{ ExistedClientDescription.head_office_postcode }}
              {{ ExistedClientDescription.head_office_county }}
              {{ ExistedClientDescription.head_office_country }}
            </vs-list-item>
            <vs-list-item title="Registered Office Address">
              {{ ExistedClientDescription.registered_office_address_1 }}
              {{ ExistedClientDescription.registered_office_address_2 }}
              {{ ExistedClientDescription.registered_office_address_3 }}
              {{ ExistedClientDescription.registered_office_city }}
              {{ ExistedClientDescription.registered_office_postcode }}
              {{ ExistedClientDescription.registered_office_county }}
              {{ ExistedClientDescription.registered_office_country }}
            </vs-list-item>
            <template v-for="(satellite, index) in ExistedClientDescription.satellite_office">
              <vs-list-item :title="'Satellite Office ' + (index + 1)" :key="index">
                <template v-for="(phone, index3) in satellite.phone">
                  <div :key="index3" v-if="phone.satellite_office_id == satellite.id">
                    {{ phone.phone_no }}
                  </div>
                </template>
                {{ satellite.address_1 }}
                {{ satellite.address_2 }}
                {{ satellite.address_3 }}
                {{ satellite.town }}
                {{ satellite.county }}
                {{ satellite.postcode }}

                <template v-for="(country, index2) in satellite.country">
                  <div :key="index2" v-if="country.satellite_office_id == satellite.id">
                    {{ country.name_1 }}
                    {{ country.name_2 }}
                    {{ country.name_3 }}
                  </div>
                </template>
              </vs-list-item>
            </template>
          </vs-list>

          <vs-list>
            <vs-list-header title="Websites" color="success"></vs-list-header>
            <template v-for="(web, index) in ExistedClientDescription.web">
              <div :key="index">
                {{ web.url }}
              </div>
            </template>
          </vs-list>
          <vs-list>
            <vs-list-header title="LinkedIn" color="success"></vs-list-header>
            <template v-for="(linkedin, index) in ExistedClientDescription.linkedin">
              <div :key="index">
                {{ linkedin.url }}
              </div>
            </template>
          </vs-list>
        </vs-popup>
      </template>
    </div>
  </div>
</template>
<script>
// Store Module
import axios from "@/axios.js";
import defineAbilitiesFor from "@/config/abilities";
import moduleClientsManagement from "@/store/clients-management/moduleClientsManagement.js";
import vSelect from "vue-select";
import ClientAutocomplete from "@/components/autocomplete/ClientsAutocomplete.vue";
import moduleAccountsManagement from "@/store/accounts-management/moduleAccountsManagement.js";
import AccountAutocomplete from "@/components/autocomplete/AccountsAutocomplete.vue";
import moment from "moment";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import _ from "lodash";
export default {
  data() {
    return {
      registered_office_country_validation: null,
      head_office_country_validation: null,
      selected_parent_company: null,
      selected_registration_jurisdiction: null,
      selected_vertical: null,
      selected_sic_code: null,
      selected_registered_office_country: null,
      selected_head_office_country: null,
      configDatePicker: {
        enableTime: false,
        format: "d/m/Y",
        altFormat: "d/m/Y",
        altInput: true
      },
      nda_document: null,
      sow_document: null,
      nda_completed: false,
      sow_completed: false,
      nda_due_by: null,
      sow_due_by: null,
      nda_expires_on: null,
      sow_expires_on: null,
      email_provided: false,
      email_due_by: null,
      email_host: null,

      abilities: null,

      companySearchComponentKey: 0,
      accounts: [],
      showHeadOfficeCountryField: true,
      showEditAutocomplete: false,
      telephone_show_no: 5,
      linkedin_show_no: 5,
      website_show_no: 5,
      clientDescription: {},

      clientExists: false,
      popupActive: false,
      websiteExists: false,
      linkedinExists: false,
      parent_name: null,
      RegistrationJurisdiction: null,
      verticalName: null,
      headOfficeIsRegisteredOffice: false,
      old_head_office_address_1: null,
      old_head_office_address_2: null,
      old_head_office_address_3: null,
      old_head_office_city: null,
      old_head_office_county: null,
      old_head_office_postcode: null,
      old_head_office_country: null,
      old_company_registration_number: null,
      IsSoleTrader: false,
      account_id: null,
      clients: {
        web: null,
        phone: null,
        linkedin: null,
        main_counter: 0,
        vertical: null,
        phoneTypes: [],
        phoneType: [],
        joinedPhoneAndTypes: [],
        joinedSicAndDescription: [],
        websites: [],
        linkedins: [],
        phoneWithTypes: [],
        verticals: [],
        vertical: null,
        sic_code: null,
        sic_code_description: null,
      },
      user_id: null,
      user_role: null

    };
  },
  components: {
    "v-select": vSelect,
    ClientAutocomplete,
    AccountAutocomplete,
    flatPickr
  },
  created() {
    var self = this;
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    self.user_id = userInfo["uid"];
    self.user_role = userInfo["userRole"];
    defineAbilitiesFor().then(function (data) {
      self.abilities = data;
    });
    if (!moduleClientsManagement.isRegistered) {
      this.$store.registerModule("clientsManagement", moduleClientsManagement);
      moduleClientsManagement.isRegistered = true;
    }
    if (!moduleAccountsManagement.isRegistered) {
      this.$store.registerModule(
        "accountsManagement",
        moduleAccountsManagement
      );
      moduleAccountsManagement.isRegistered = true;
    }
  },
  watch: {
    website_show_no(val) {
      if (val) {
        this.clientDescription.webShow = this.clientDescription.web.slice(
          0,
          val
        );
      }
    },
    linkedin_show_no(val) {
      if (val) {
        this.clientDescription.linkedinShow = this.clientDescription.linkedin.slice(
          0,
          val
        );
      }
    },
    telephone_show_no(val) {
      if (val) {
        this.clientDescription.phone = this.clientDescription.phone.slice(
          0,
          val
        );
      }
    },
    "clientDescription.is_sole_trader"(val) {

      this.clientDescription.registered_office_country = this.$refs.clientAddRegisteredOfficeCountryRef.$refs.suggestComponent.value
      this.clientDescription.registered_office_country = this.$refs.clientAddRegisteredOfficeCountryRef.$refs.suggestComponent.input.value

      this.clientDescription.head_office_country = this.$refs.clientAddHeadOfficeCountryRef.$refs.suggestComponent.value
      this.clientDescription.head_office_country = this.$refs.clientAddHeadOfficeCountryRef.$refs.suggestComponent.input.value



      if (val) {
        this.clientDescription.IsSoleTraderFields = {
          company_name: this.clientDescription.company_name,
          head_office_country: this.clientDescription.head_office_country
        };

        if (this.clientDescription.head_office_country == null || this.clientDescription.head_office_country == '') {
          this.head_office_country_validation = 'The Head Office Country field is required'
          this.registered_office_country_validation = null
        } else {
          this.head_office_country_validation = null
        }




      } else {
        this.clientDescription.IsSoleTraderFields = {
          company_registration_number: this.clientDescription
            .company_registration_number,
          registered_office_country: this.clientDescription.registered_office_country
        };

        if (this.clientDescription.registered_office_country == null || this.clientDescription.registered_office_country == '') {
          this.registered_office_country_validation = 'The Registered Office Country field is required'
          this.head_office_country_validation = null
        } else {
          this.registered_office_country_validation = null
        }
      }



    },
    // "clientDescription.head_office_country"(val) {
    //   if (val != this.old_head_office_country) {
    //     this.checkCompanyExists();
    //   }
    // },
    // "clientDescription.company_registration_number"(val) {
    //   if (val != this.old_company_registration_number) {
    //     this.checkCompanyExists();
    //   }
    // },
    headOfficeIsRegisteredOffice(val) {
      if (val) {
        this.clientDescription.head_office_address_1 = this.clientDescription.registered_office_address_1;
        this.clientDescription.head_office_address_2 = this.clientDescription.registered_office_address_2;
        this.clientDescription.head_office_address_3 = this.clientDescription.registered_office_address_3;
        this.clientDescription.head_office_city = this.clientDescription.registered_office_city;
        this.clientDescription.head_office_county = this.clientDescription.registered_office_county;
        this.clientDescription.head_office_postcode = this.clientDescription.registered_office_postcode;
        this.$refs.clientAddHeadOfficeCountryRef.$refs.suggestComponent.value = this.$refs.clientAddRegisteredOfficeCountryRef.$refs.suggestComponent.value
        this.$refs.clientAddHeadOfficeCountryRef.$refs.suggestComponent.input.value = this.$refs.clientAddRegisteredOfficeCountryRef.$refs.suggestComponent.input.value
      } else {
        this.$refs.clientAddHeadOfficeCountryRef.$refs.suggestComponent.input.value = this.clientDescription.head_office_country;
        this.$refs.clientAddHeadOfficeCountryRef.$refs.suggestComponent.value = this.clientDescription.head_office_country;
        this.clientDescription.head_office_address_1 = this.old_head_office_address_1;
        this.clientDescription.head_office_address_2 = this.old_head_office_address_2;
        this.clientDescription.head_office_address_3 = this.old_head_office_address_3;
        this.clientDescription.head_office_city = this.old_head_office_city;
        this.clientDescription.head_office_county = this.old_head_office_county;
        this.clientDescription.head_office_postcode = this.old_head_office_postcode;
        if (this.$refs.clientAddHeadOfficeCountryRef.$refs.suggestComponent.value != null || this.$refs.clientAddHeadOfficeCountryRef.$refs.suggestComponent.value != '') {
          this.head_office_country_validation = null
        }

        if (this.$refs.clientAddRegisteredOfficeCountryRef.$refs.suggestComponent.value != null || this.$refs.clientAddRegisteredOfficeCountryRef.$refs.suggestComponent.value != '') {
          this.registered_office_country_validation = null
        }
      }
    }
  },
  mounted() {
    this.getPhoneTypes();

  },
  methods: {
    getSicCodes(inputValue) {
      return this.$store
        .dispatch("accountsManagement/getSicCodes", inputValue)
        .then(response => {
          let data = moduleAccountsManagement.state.sic_codes;
          // console.log(data);
          let mappedArray = [];
          for (const property in data) {
            mappedArray.push({
              id: data[property].id,
              name: data[property].code + ' - ' + data[property].description
            });
          }
          return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    fetchAccountDetails(accountId) {
      this.$store
        .dispatch("accountsManagement/fetchAccount", accountId)
        .then(res => {




          this.clientDescription = res.data;
          this.clientDescription.IsSoleTraderFields = {};
          this.old_head_office_address_1 = this.clientDescription.head_office_address_1;
          this.old_head_office_address_2 = this.clientDescription.head_office_address_2;
          this.old_head_office_address_3 = this.clientDescription.head_office_address_3;
          this.old_head_office_city = this.clientDescription.head_office_city;
          this.old_head_office_county = this.clientDescription.head_office_county;
          this.old_head_office_postcode = this.clientDescription.head_office_postcode;
          this.old_is_sole_trader = this.clientDescription.is_sole_trader;



          this.$refs.clientAddRegisteredOfficeCountryRef.$refs.suggestComponent.input.value = this.clientDescription.registered_office_country;
          this.$refs.clientAddRegisteredOfficeCountryRef.$refs.suggestComponent.value = this.clientDescription.registered_office_country;

          this.$refs.clientAddHeadOfficeCountryRef.$refs.suggestComponent.input.value = this.clientDescription.head_office_country;
          this.$refs.clientAddHeadOfficeCountryRef.$refs.suggestComponent.value = this.clientDescription.head_office_country;

          this.old_company_registration_number = this.clientDescription.company_registration_number;

          this.clientDescription.sic_code = this.clientDescription.sic_code.filter(function (e) {
            e.id = e.sic_code_detail.id
            e.name = e.sic_code_detail.code + ' - ' + e.sic_code_detail.description
            return e
          })



          this.clientDescription.phone = this.clientDescription.phone.filter(function (ele) {
            ele.phone_no = ele.phone_no
            ele.phone_type = ele.phone_type[0].type
            return ele
          })

          // console.log("ph" , this.clientDescription.phone)



          this.clientDescription.phone = this.clientDescription.phone.slice(
            0,
            this.telephone_show_no
          );

          this.clientDescription.parent = null
          // if (this.clientDescription.parent) {
          //   this.showParentName(this.clientDescription.parent);
          // }
          if (this.clientDescription.registration_jurisdiction) {
            this.showRegistrationJurisdiction(
              this.clientDescription.registration_jurisdiction
            );
          }



          if (this.clientDescription.vertical) {
            this.showVertical(this.clientDescription.vertical);
          }

          this.clientDescription.satellite_office.forEach(element => {
            if (element.phone.length > 0) {
              if (Array.isArray(element.phone)) {
                element.phone = element.phone[0].phone_no

              }
            }
          });

          this.clientDescription.satellite_office = this.clientDescription.satellite_office.map(
            ele => {
              let counter = 0;
              ele.counter = ++this.clients.main_counter;
              return ele;
            }
          );



        })
        .catch(err => {
          console.log(err)
          if (err.response.status === 404) {
            this.clientDescription = true;
            return;
          }
          console.error(err);
        });
    },
    handleChildEvent() {
      this.clients = moduleAccountsManagement.state.accounts.datas;
      this.account_id = this.clients[0].id
      this.fetchAccountDetails(this.clients[0].id);
      this.getPhoneTypes();

    },
    searchAccount(inputValue) {
      return this.$store
        .dispatch("accountsManagement/getCompanyOrRegistrationNo", inputValue)
        .then(response => {
          if (response) {
            let data =
              moduleAccountsManagement.state.company_or_registration_no;
            if (data) {
              // console.log(data);
              let mappedArray = [];
              for (const property in data) {
                mappedArray.push({
                  id: data[property].id,
                  name:
                    data[property].company_name +
                    " - " +
                    data[property].company_registration_number
                });
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        });
    },
    editHeadOfficeCountry() {
      this.showHeadOfficeCountryField = false;
      this.showEditAutocomplete = true;
      this.$refs.EditAutoComplete.$refs.suggestComponent.isInFocus = true;
      this.$refs.EditAutoComplete.$refs.suggestComponent.isClicking = true;
      this.$refs.EditAutoComplete.$refs.suggestComponent.input.value = this.clientDescription.head_office_country;
      this.$refs.EditAutoComplete.$refs.suggestComponent.value = this.clientDescription.head_office_country;
    },
    goBack: function () {
      this.$router.go(-1);
    },
    showGroupCompanies() {
      const parentId = this.clientDescription.parent;
      this.$store
        .dispatch("clientsManagement/getGroupCompanies", parentId)
        .then(res => {
          this.groupCompanies = res.data;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.groupCompanies = true;
            return;
          }
          console.error(err);
        });
    },
    showParentName(parentId) {
      this.$store
        .dispatch("clientsManagement/getParentCompany", parentId)
        .then(res => {
          //     this.$refs.ParentRef.$refs.suggestComponent.input.value = res.data.company_name;
          // this.$refs.ParentRef.$refs.suggestComponent.value = res.data.company_name;
          //     console.log(res.data)
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.parent_name = true;
            return;
          }
          console.error(err);
        });
    },
    showRegistrationJurisdiction(countryId) {
      this.$store
        .dispatch("clientsManagement/getCountry", countryId)
        .then(res => {
          this.$refs.RegistrationJurisdictionRef.$refs.suggestComponent.input.value = res.data.name_1
          this.$refs.RegistrationJurisdictionRef.$refs.suggestComponent.value = res.data.name_1


        })
        .catch(err => {
          if (err.response.status === 404) {
            return;
          }
          console.error(err);
        });
    },
    showVertical(verticalId) {
      this.$store
        .dispatch("clientsManagement/getVertical", verticalId)
        .then(res => {
          this.$refs.VerticalRef.$refs.suggestComponent.input.value = res.data.vertical;
          this.$refs.VerticalRef.$refs.suggestComponent.value = res.data.vertical;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    removeSelectedSiteAddress(site) {
      this.clientDescription.satellite_office = this.clientDescription.satellite_office.filter(
        item => {
          return item.counter != site.counter;
        }
      );
    },
    addSiteOffice() {
      this.clientDescription.satellite_office.push({
        counter: ++this.clients.main_counter,
        address_1: null,
        address_2: null,
        address_3: null,
        city: null,
        county: null,
        postcode: null,
        country: null,
        phone: null
      });
      // console.log(this.clients.main_counter);
      // console.log(this.clients.satellite);
    },
    removeSelectedWeb(url) {
      this.clientDescription.web = this.clientDescription.web.filter(item => {
        return item != url;
      });
    },
    removeSelectedLinkedin(url) {
      this.clientDescription.linkedin = this.clientDescription.linkedin.filter(
        item => {
          return item != url;
        }
      );
    },
    removeSelectedPhone(phone) {
      this.clientDescription.phone = this.clientDescription.phone.filter(
        item => {
          return item != phone;
        }
      );
      this.clientDescription.phone = this.clientDescription.phone;
    },
    removeSelectedSicCode(sic_code) {
      this.clientDescription.sic_code = this.clientDescription.sic_code.filter(
        item => {
          return item != sic_code;
        }
      );
      this.clientDescription.phone = this.clientDescription.phone;
    },
    removeNewSelectedSicCode(selected) {
      this.clients.joinedSicAndDescription = this.clients.joinedSicAndDescription.filter(
        item => {
          return item != selected;
        }
      );
    },
    removeNewSelectedPhone(selected) {
      this.clients.joinedPhoneAndTypes = this.clients.joinedPhoneAndTypes.filter(
        item => {
          return item != selected;
        }
      );
    },
    validDomain(userInput) {
      if (userInput) {
        var res = userInput.match(
          /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
        );
        if (res == null) {
          return false;
        }
      }
      return true;
    },
    addPhoneNumbers() {
      // if (
      //   this.clients.phone &&
      //   this.clients.phoneType &&
      //   !this.clients.joinedPhoneAndTypes.includes(
      //     this.clients.phoneType.name + " - " + this.clients.phone
      //   )
      // )
      //   this.clients.joinedPhoneAndTypes.push(
      //     this.clients.phoneType.name + " - " + this.clients.phone
      //   );
      //  console.log(this.clientDescription)


      let mappedPhoneTypes = {};
      mappedPhoneTypes.phone_no = this.clients.phone;
      mappedPhoneTypes.phone_type = this.clients.phoneType.slug;
      this.clientDescription.phone.push(mappedPhoneTypes);
      this.clients.phone = null;
      this.clients.phoneType = null;
    },
    addSicCode() {



      this.clientDescription.sic_code.push(
        moduleAccountsManagement.sic_codes_selected
      );

      this.$refs.SicCodeRef.$refs.suggestComponent.selected = null
      this.$refs.SicCodeRef.$refs.suggestComponent.input.value = null
      this.$refs.SicCodeRef.$refs.suggestComponent.value = null
    },
    addWebsite() {
      if (
        this.clients.web &&
        !this.clientDescription.web.includes(this.clients.web)
      )
        this.clientDescription.web.push({ url: this.clients.web });
      this.clients.web = null;
    },
    addLinkedin() {
      if (
        this.clients.linkedin &&
        !this.clientDescription.linkedin.includes(this.clients.linkedin)
      )
        this.clientDescription.linkedin.push({ url: this.clients.linkedin });
      this.clients.linkedin = null;
    },
    submitForm() {

      this.clientDescription.registered_office_country = this.$refs.clientAddRegisteredOfficeCountryRef.$refs.suggestComponent.value
      this.clientDescription.registered_office_country = this.$refs.clientAddRegisteredOfficeCountryRef.$refs.suggestComponent.input.value

      this.clientDescription.head_office_country = this.$refs.clientAddHeadOfficeCountryRef.$refs.suggestComponent.value
      this.clientDescription.head_office_country = this.$refs.clientAddHeadOfficeCountryRef.$refs.suggestComponent.input.value



      this.$validator.validateAll().then(result => {
        if (result) {







          if (this.clientDescription.is_sole_trader) {

            if (this.clientDescription.head_office_country == null || this.clientDescription.head_office_country == '') {
              this.head_office_country_validation = 'The Head Office Country field is required'
              this.registered_office_country_validation = null
              return false
            } else {
              this.head_office_country_validation = null
            }


            this.clientDescription.IsSoleTraderFields = {
              company_name: this.clientDescription.company_name,
              head_office_country: this.clientDescription.head_office_country
            };
          } else {

            if (this.clientDescription.registered_office_country == null || this.clientDescription.registered_office_country == '') {
              this.registered_office_country_validation = 'The Registered Office Country field is required'
              this.head_office_country_validation = null
              return false
            } else {
              this.registered_office_country_validation = null
            }



            this.clientDescription.IsSoleTraderFields = {
              company_registration_number: this.clientDescription
                .company_registration_number,
              registered_office_country: this.clientDescription.registered_office_country
            };
          }












          if (moduleClientsManagement.autocomplete_selected) {
            this.clientDescription.parent =
              moduleClientsManagement.autocomplete_selected.id;
          }
          if (moduleAccountsManagement.vertical_selected) {
            this.clientDescription.vertical =
              moduleAccountsManagement.vertical_selected.id;
          }
          if (moduleAccountsManagement.countries_selected) {
            this.clientDescription.registration_jurisdiction =
              moduleAccountsManagement.countries_selected.id;
          }

          this.clientDescription.id = this.$route.params.clientId;

          // this.clientDescription.phoneWithTypes = [];
          // this.clientDescription.phone.map(phone_ele => {
          //   phone_ele.phone_type.map(phone_type_ele => {
          //     if (phone_type_ele.phone_id == phone_ele.id) {
          //       let mappedPhoneTypes = {};
          //       mappedPhoneTypes.phone_no = phone_ele.phone_no;
          //       mappedPhoneTypes.phone_type = phone_type_ele.type;
          //       this.clientDescription.phoneWithTypes.push(mappedPhoneTypes);
          //     }
          //   });
          // });
          // this.clientDescription.phoneWithTypes = _.unionBy(
          //   this.clientDescription.phoneWithTypes,
          //   this.clients.phoneWithTypes,
          //   "phone_no"
          // );




          // console.log(this.clientDescription.satellite_office)
          // return false

          this.clientDescription.satellite_office.forEach(element => {
            if (element.phone.length > 0) {
              if (Array.isArray(element.phone)) {
                element.phone = element.phone[0].phone_no

              }
            }
          });




          // this.clientDescription.sicCodeWithDescription = [];
          // this.clientDescription.sic_code.map(sic_ele => {
          //   let mappedPhoneTypes = {};
          //   mappedPhoneTypes.code = sic_ele.code;
          //   mappedPhoneTypes.description = sic_ele.description;
          //   this.clientDescription.sicCodeWithDescription.push(
          //     mappedPhoneTypes
          //   );
          // });
          // this.clientDescription.sicCodeWithDescription = _.unionBy(
          //   this.clientDescription.sicCodeWithDescription,
          //   this.clients.sicCodeWithDescription,
          //   "code"
          // );
          this.clientDescription.nda_completed = this.nda_completed
          this.clientDescription.sow_completed = this.sow_completed
          this.clientDescription.nda_due_by = this.nda_due_by
          this.clientDescription.sow_due_by = this.sow_due_by
          this.clientDescription.nda_expires_on = this.nda_expires_on
          this.clientDescription.sow_expires_on = this.sow_expires_on
          this.clientDescription.email_provided = this.email_provided
          this.clientDescription.email_host = this.email_host
          this.clientDescription.email_due_by = this.email_due_by
          this.clientDescription.account_id = this.account_id
          this.clientDescription.user_id = this.user_id
          //   if(this.nda_document == null){
          //      this.clientDescription.nda_document = null
          //   }else{
          //     this.clientDescription.nda_document = this.nda_document
          //   }
          //  if(this.sow_document == null){
          //      this.clientDescription.sow_document = null
          //   }else{
          //      this.clientDescription.sow_document = this.sow_document
          //   }
          this.addClients();
          // if form have no errors
        } else {
          // form have errors
        }
      });
    },
    uploadNDADocument(e) {
      const files = e.target.files;
      const ndaDocument = files[0];
      if (!ndaDocument) return;
      if (
        ndaDocument.type != "application/pdf" &&
        ndaDocument.type != "text/plain" &&
        ndaDocument.type !=
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document" &&
        ndaDocument.type !=
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
        ndaDocument.type != "text/csv"
      ) {
        this.$vs.notify({
          color: "danger",
          title: "Invalid File",
          text:
            "The NDA Document Must Be A File Of Type: Docx, Doc, Pdf, Xlsx, Xls, Csv, Txt."
        });
        return;
      }
      this.upload_file_name = ndaDocument.name;
      let axois_url =
        this.$base_url + "/api/clients/document_nda_upload";
      let formData = new FormData();
      formData.append("file", ndaDocument);
      axios
        .post(axois_url, formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(response => {
          if (response.data.status == "success") {
            this.clientDescription.nda_document = response.data.data;
          }
        })
        .catch(function () {
          console.log("FAILURE!!");
        });
    },
    uploadSOWDocument(e) {
      const files = e.target.files;
      const sowDocument = files[0];
      if (!sowDocument) return;
      if (
        sowDocument.type != "application/pdf" &&
        sowDocument.type != "text/plain" &&
        sowDocument.type !=
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document" &&
        sowDocument.type !=
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
        sowDocument.type != "text/csv"
      ) {
        this.$vs.notify({
          color: "danger",
          title: "Invalid File",
          text:
            "The SOW Document Must Be A File Of Type: Docx, Doc, Pdf, Xlsx, Xls, Csv, Txt."
        });
        return;
      }
      this.upload_file_name = sowDocument.name;
      let axois_url =
        this.$base_url + "/api/clients/document_sow_upload";
      let formData = new FormData();
      formData.append("file", sowDocument);
      axios
        .post(axois_url, formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(response => {
          if (response.data.status == "success") {
            this.clientDescription.sow_document = response.data.data;
          }
        })
        .catch(function () {
          console.log("FAILURE!!");
        });
    },
    addClients() {
      this.$store
        .dispatch("clientsManagement/addClient", this.clientDescription)
        .then(res => {
          if (res.data.status == "fail") {
            this.checkCompanyExists()
          } else {
            this.$vs.notify({
              color: "success",
              title: "Client",
              text: res.data.message
            });
            this.$router.push({ path: "/clients" });
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    checkCompanyExists() {
      if (this.clientDescription.is_sole_trader) {
        this.clientDescription.IsSoleTraderFields = {
          company_name: this.clientDescription.company_name,
          head_office_country: this.clientDescription.head_office_country
        };
      } else {
        this.clientDescription.IsSoleTraderFields = {
          company_registration_number: this.clientDescription
            .company_registration_number,
          registered_office_country: this.clientDescription.registered_office_country
        };
      }

      this.clientDescription.IsSoleTraderFields.is_sole_trader = this.clientDescription.is_sole_trader
      this.$store
        .dispatch(
          "clientsManagement/checkCompanyExists",
          this.clientDescription.IsSoleTraderFields
        )
        .then(res => {
          if (res.data.status == "fail") {
            this.ExistedClientDescription = res.data.data;
            this.clientExists = true;
            this.popupActive = true;
          } else {
            return;
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getPhoneTypes() {

      this.$store
        .dispatch("clientsManagement/getPhoneTypes")
        .then(res => {
          this.clients.phoneTypes = res.data;
          this.clients.phoneTypes = this.clients.phoneTypes.filter(
            item => item.name != "Site Switchboard"
          );
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getVerticals(inputValue) {
      return this.$store
        .dispatch("clientsManagement/getVerticals", inputValue)
        .then(response => {
          let data = moduleClientsManagement.state.verticals;
          let mappedArray = [];
          for (const property in data) {
            mappedArray.push({
              id: data[property].id,
              name: data[property].vertical
            });
          }
          return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getCountries(inputValue) {
      return this.$store
        .dispatch("clientsManagement/getCountries", inputValue)
        .then(response => {
          let data = moduleClientsManagement.state.countries;
          // console.log(data);
          let mappedArray = [];
          for (const property in data) {
            mappedArray.push({
              id: data[property].id,
              name: data[property].name_1
            });
          }
          return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    accept() {
      this.popupActive = false
      // this.handleChildEvent()
      // console.log(this.clientDescription)
      // this.$vs.dialog({
      //   color: "primary",
      //   title: `Confirm`,
      //   text: "Confirmed this client already exists.",
      //   accept: (this.popupActive = false)
      // });
    },
    reject() {
      // this.popupActive = false;
      // this.$router.push({ path: "/clients" });
      this.$router.go(0);
    },
    getParentCompany(inputValue) {
      return this.$store
        .dispatch("clientsManagement/searchAutocomplete", inputValue)
        .then(response => {
          let data = JSON.parse(JSON.parse(JSON.stringify(response.data)));
          let mappedArray = [];
          for (const property in data) {
            mappedArray.push({
              id: data[property].uuid,
              name: data[property].company_name
            });
          }
          return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    }
  }
};
</script>
<style>
.flat-pick {
  padding: 0.7rem;
  border-radius: 5px;
  font-size: 1rem;
  color: #626262;
  cursor: pointer;
}
</style>
<style scoped>
.removeButton {
  cursor: pointer;
}

.inputx {
  width: 50px;
}

.searchbox {
  width: 582px;
}
</style>
